import React, { useCallback } from 'react'
import { get } from 'lodash'

import { ModalActiveKit } from 'components/ModalActiveKit'

import { useDisclosure } from '@chakra-ui/react'

import { ActionProps } from './types'
import { WrapperAction } from './WrapperAction'

export const ActiveKitAction = <T extends unknown>({
  record,
  options,
}: ActionProps<T>) => {
  const modalActiveKitDisclosure = useDisclosure()

  const activationCode = get(record, 'activationCode')
  const { callback, actionType = 'menu', reload, ...optionsRest } = options

  if (!reload) {
    throw new Error('reload is required')
  }

  const cta = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>, data: T) => {
      modalActiveKitDisclosure.onOpen()

      if (callback) {
        callback(e, data)
      }
    },
    [modalActiveKitDisclosure, callback]
  )

  return (
    <>
      <ModalActiveKit
        reload={reload}
        activationCode={activationCode}
        isOpen={modalActiveKitDisclosure.isOpen}
        onCancel={modalActiveKitDisclosure.onClose}
      />

      <WrapperAction
        cta={cta}
        record={record}
        options={optionsRest}
        actionType={actionType}
        label="Forçar status para ativado"
        tooltip="Para forçar o status para ativado, é necessário que o paciente tenha preechido a ficha clínica."
        tooltipProps={{
          shouldWrapChildren: true,
          isDisabled: !optionsRest.isDisabled,
        }}
      />
    </>
  )
}
